import { Store } from 'src/store/index';

const getUpsellTotalPrice = (store: Store) => store.upsell.upsellTotalPrice;
export default getUpsellTotalPrice;
